module.exports = {
      id: "219fb616d3de9164992b2cb9585a6ef5roofShape-saddle-with-dormers.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#219fb616d3de9164992b2cb9585a6ef5roofShape-saddle-with-dormers.svg",
      toString: function () {
        return this.url;
      }
    }